import RestApi from '~services/restApi'
import _ from 'lodash'
import { getAllBanksQuery } from '~graphql/banks.graphql'
import {
  getBankAccountsQuery,
  createBankAccountMutation,
  deleteBankAccountMutation,
  updateBankAccountMutation,
  getBankAccountByIdQuery,
  getAllBankAccountTypesQuery
} from '~graphql/bankAccounts.graphql'
import {
  getAllFinanceCategoriesQuery,
  createFinanceCategoryMutation,
  deleteFinanceCategoryMutation,
  updateFinanceCategoryMutation,
  getAllFinanceTransactionsQuery,
  createFinanceTransactionMutation,
  deleteFinanceTransactionMutation,
  updateFinanceTransactionMutation,
  getFinanceTransactionQuery,
  getFinanceCategoriesQuery,
  getFinanceCategoryQuery
} from '~graphql/finance.graphql'
import {
  getBankWebhooksByAccountQuery,
  createBankWebhookMutation,
  deleteBankWebhookMutation,
  updateBankWebhookMutation
} from '~graphql/bankWebhooks.graphql'

export default {
  storeSecret(_, secret) {
    return RestApi.storeSecret(secret.token, secret.refName, secret.refId, secret.properties)
  },
  getAllBanks({ state, dispatch }) {
    return dispatch('getItems', {
      state,
      loader: 'banks:get',
      modelName: 'banks',
      query: getAllBanksQuery,
      resultPath: 'banks.nodes'
    })
  },
  getAllBankAccountTypes({ state, dispatch }) {
    return dispatch('getItems', {
      state,
      loader: 'bankAccountTypes:get',
      modelName: 'bankAccountTypes',
      query: getAllBankAccountTypesQuery,
      resultPath: 'bankAccountTypes.nodes',
      useCache: true
    })
  },
  getBankAccounts({ state, dispatch }) {
    return dispatch('getItems', {
      state,
      loader: 'bankAccounts:get',
      modelName: 'bankAccounts',
      query: getBankAccountsQuery,
      resultPath: 'bankAccounts.nodes',
      variables: {
        filter: {
          isPartnerAccount: {
            equalTo: false
          }
        }
      }
    })
  },
  getBankAccountById({ state, dispatch }, id) {
    return dispatch('getItemById', {
      id,
      state,
      loader: 'bankAccounts:get',
      addTo: ['bankAccounts'],
      query: getBankAccountByIdQuery,
      resultPath: 'bankAccount'
    })
  },
  createBankAccount({ state, dispatch }, bankAccount) {
    return dispatch('createItem', {
      item: { bankAccount },
      state,
      loader: 'bankAccount:create',
      addTo: ['bankAccounts'],
      mutation: createBankAccountMutation,
      resultPath: 'createBankAccount.bankAccount'
    })
  },
  updateBankAccount({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      modelName: 'selectedBankAccount',
      addTo: ['bankAccounts'],
      loader: 'bankAccount:update',
      mutation: updateBankAccountMutation,
      resultPath: 'updateBankAccount.bankAccount'
    })
  },
  deleteBankAccount({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      modelName: 'selectedBankAccount',
      removeFrom: ['bankAccounts'],
      loader: 'bankAccount:delete',
      mutation: deleteBankAccountMutation
    })
  },
  setSelectedBankAccount({ state, commit }, selectedBankAccount) {
    commit('SET_ITEM', {
      state,
      item: selectedBankAccount,
      modelName: 'selectedBankAccount'
    })
  },

  getBankWebhooksByAccount({ state, dispatch }, bankAccountId) {
    return dispatch('getItems', {
      state,
      loader: 'bankWebhooks:getByAccount',
      modelName: 'bankWebhooks',
      query: getBankWebhooksByAccountQuery,
      variables: { bankAccountId },
      resultPath: 'bankWebhooks.nodes'
    })
  },
  createBankWebhook({ state, dispatch }, bankWebhook) {
    return dispatch('createItem', {
      item: { bankWebhook },
      state,
      loader: 'bankWebhook:create',
      addTo: ['bankWebhooks'],
      mutation: createBankWebhookMutation,
      resultPath: 'createBankWebhook.bankWebhook'
    })
  },
  updateBankWebhook({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      modelName: 'selectedBankWebhook',
      addTo: ['bankWebhooks'],
      loader: 'bankWebhook:update',
      mutation: updateBankWebhookMutation,
      resultPath: 'updateBankWebhook.bankWebhook'
    })
  },
  deleteBankWebhook({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      modelName: 'selectedBankWebhook',
      removeFrom: ['bankWebhooks'],
      loader: 'bankWebhook:delete',
      mutation: deleteBankWebhookMutation
    })
  },
  setSelectedBankWebhook({ state, commit }, selectedBankWebhook) {
    commit('SET_ITEM', {
      state,
      item: selectedBankWebhook,
      modelName: 'selectedBankWebhook'
    })
  },
  getFinanceCategories({ state, dispatch }, { filter, offset, first }) {
    const defaultFilter = {
      id: {
        isNull: false
      } // used to allow empty filter
    }
    const mergedFilter = _.merge(filter, defaultFilter)

    return dispatch('getItems', {
      state,
      loader: 'financeCategories:get',
      modelName: 'financeCategories',
      query: getFinanceCategoriesQuery,
      resultPath: 'financeCategoryTrees.nodes',
      variables: {
        filter: mergedFilter,
        offset,
        first
      }
    })
  },
  getFinanceCategoryById({ state, dispatch }, id) {
    return dispatch('getItemById', {
      id,
      state,
      loader: 'financeCategory:get',
      modelName: 'selectedFinanceCategory',
      query: getFinanceCategoryQuery,
      resultPath: 'financeCategory'
    })
  },
  getAllFinanceCategories({ state, dispatch }) {
    return dispatch('getItems', {
      state,
      loader: 'financeCategories:get',
      modelName: 'financeCategories',
      query: getAllFinanceCategoriesQuery,
      resultPath: 'financeCategoryTrees.nodes'
    })
  },
  createFinanceCategory({ state, dispatch }, financeCategory) {
    return dispatch('createItem', {
      item: { financeCategory },
      state,
      loader: 'financeCategory:create',
      addTo: ['financeCategories'],
      mutation: createFinanceCategoryMutation,
      resultPath: 'createFinanceCategory.financeCategory'
    })
  },
  updateFinanceCategory({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      modelName: 'selectedFinanceCategory',
      addTo: ['financeCategories'],
      loader: 'financeCategory:update',
      mutation: updateFinanceCategoryMutation,
      resultPath: 'updateFinanceCategory.financeCategory'
    })
  },
  deleteFinanceCategory({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      modelName: 'selectedFinanceCategory',
      removeFrom: ['financeCategories'],
      loader: 'financeCategory:delete',
      mutation: deleteFinanceCategoryMutation
    })
  },
  setSelectedFinanceCategory({ state, commit }, selectedFinanceCategory) {
    commit('SET_ITEM', {
      state,
      item: selectedFinanceCategory,
      modelName: 'selectedFinanceCategory'
    })
  },
  getAllFinanceTransactions({ state, dispatch, commit }, { filter, offset, first, orderBy }) {
    commit('SET_ITEM', {
      state,
      item: [],
      modelName: 'financeTransactions'
    })
    const defaultFilter = {
      id: {
        isNull: false
      } // used to allow empty filter
    }
    const mergedFilter = _.merge(filter, defaultFilter)

    return dispatch('getItems', {
      state,
      loader: 'financeTransactions:get',
      modelName: 'financeTransactions',
      query: getAllFinanceTransactionsQuery,
      resultPath: 'financeTransactions.nodes',
      totalPath: 'financeTransactions.totalCount',
      totalModelName: 'financeTransactionsCount',
      variables: {
        filter: mergedFilter,
        offset,
        first,
        orderBy
      }
    })
  },
  getFinanceTransferGroup({ state, dispatch }, transferGroupId) {
    const filter = {
      transferGroupId: {
        equalTo: transferGroupId
      } // used to allow empty filter
    }

    return dispatch('getItems', {
      state,
      loader: 'financeTransactions:get',
      query: getAllFinanceTransactionsQuery,
      resultPath: 'financeTransactions.nodes',
      totalPath: 'financeTransactions.totalCount',
      variables: {
        filter
      }
    })
  },
  getFinanceTransactionById({ state, dispatch }, id) {
    return dispatch('getItemById', {
      id,
      state,
      loader: 'financeTransaction:get',
      modelName: 'selectedFinanceTransaction',
      query: getFinanceTransactionQuery,
      resultPath: 'financeTransaction',
      useCache: false
    })
  },
  createFinanceTransaction({ state, dispatch }, financeTransaction) {
    return dispatch('createItem', {
      item: { financeTransaction },
      state,
      loader: 'financeTransaction:create',
      addTo: ['financeTransactions'],
      mutation: createFinanceTransactionMutation,
      resultPath: 'createFinanceTransaction.financeTransaction'
    })
  },
  updateFinanceTransaction({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      modelName: 'selectedFinanceTransaction',
      addTo: ['financeTransactions'],
      loader: 'financeTransaction:update',
      mutation: updateFinanceTransactionMutation,
      resultPath: 'updateFinanceTransaction.financeTransaction'
    })
  },
  deleteFinanceTransaction({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      modelName: 'selectedFinanceTransaction',
      removeFrom: ['financeTransactions'],
      loader: 'financeTransaction:delete',
      mutation: deleteFinanceTransactionMutation
    })
  },
  setSelectedFinanceTransaction({ state, commit }, selectedFinanceTransaction) {
    commit('SET_ITEM', {
      state,
      item: selectedFinanceTransaction,
      modelName: 'selectedFinanceTransaction'
    })
  }
}
